export function campaignsOrdered(state) {
	if (!state.campaigns || !state.campaigns.length) return [];

	return [
		...state.campaigns.filter(c => c.status === 1),
		...state.campaigns.filter(c => c.status === -1),
		...state.campaigns.filter(c => Math.abs(c.status) !== 1),
	];
}
